"use strict";

define('components/filter_bar/filters/link_filters',[], function() {
    var linkFiltersComponent = {
        initWithContext: function(context) {
            _initData(context);

            // Click handlers for filter links
            var links = context.linkFiltersData.navPills.find('a');
            links.click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                var clickedLI = $(this).closest('li');
                if (clickedLI.hasClass('disabled')) return;

                var currentlyActive = context.linkFiltersData.navPills.find('li.active');
                currentlyActive.each(function() {
                    var li = $(this);
                    li.removeClass('active');

                    var filter = li.data('filter');
                    if (filter) {
                        context.removeFilter(filter);
                    }
                });

                clickedLI.addClass('active');
                context.applyFilterFromString(clickedLI.data('filter'));

                context.markDirtyState();
            });
        },

        resetToDefaultUI: function(context) {
            context.linkFiltersData.navPills.find('li.active').removeClass('active');
            context.linkFiltersData.navPills.find('li:first').addClass('active');
        }
    };

    function _initData(context) {
        context.linkFiltersData = {
            navPills: context.buttonbarNode.find('ul.nav-pills')
        };
    }

    return linkFiltersComponent;
});
